import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FlyFreelyConstants } from '../constants';
import {
    FormVersionMissionCountDto,
    FormVersionMissionSearchCriteria
} from '../model/api';
import { DownloadService } from './download.service';
import { computePath, httpParamSerializer } from './service.helpers';

@Injectable({
    providedIn: 'root'
})
export class FormReportService {
    private baseUrl: string;
    private changeSource = new Subject<void>();
    change$ = this.changeSource.asObservable();

    constructor(
        constants: FlyFreelyConstants,
        private http: HttpClient,
        private downloadService: DownloadService,
    ) {
        this.baseUrl = constants.SITE_URL;
    }

    findVersionUsageCount(
        organisationId: number,
        orOrganisationId: number,
        formIdList: number[],
        authorityIds: number[],
        startTime: string,
        endTime: string,
        exportFlights: boolean
    ) {
        const criteria: FormVersionMissionSearchCriteria = {
            organisationId,
            orOrganisationId,
            formIdList,
            authorityIds,
            startTime,
            endTime,
            exportFlights
        };

        return this.http.get<FormVersionMissionCountDto[]>(
            `${this.baseUrl}/webapi/formReports/formVersionCount`,
            { params: httpParamSerializer(criteria) }
        );
    }

    downloadFormReport(
        organisationId: number,
        orOrganisationId: number,
        authorityIds: number[],
        formVersionId: number,
        startTime: string,
        endTime: string,
        exportFlights?: boolean
    ) {
        const queryString = httpParamSerializer({
            organisationId,
            orOrganisationId,
            authorityIds,
            startTime,
            endTime,
            formVersionId,
            exportFlights
        }).toString();

        return this.downloadService.downloadFromUrl(
            computePath(`/webapi/formReports/missions/csv?${queryString}`)
        );
    }
}
